import React from 'react';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Modal, Form, Row, Col, Image, Button } from 'react-bootstrap';

import InputGroupText from '@components/InputGroupText/InputGroupText';
import LoaderBtn from '@components/LoaderBtn/loaderBtn';

import {
    cancelButtonColor,
    confirmButtonColor,
} from '@constants/general.const';

import { faBuildings } from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import NewOffice from '@images/new-office.svg';

import { addOfficeData } from '@app/CreateOrganization/step2/functions';
import { updateCurrentStep } from '@app/Auth/Login/loginSlice';

import { IStep2Props } from './step2.interface';

const OfficePopupStep2 = ({
    showPopup,
    getDataListCall,
    handleClose,
    organizationId = null,
}: any) => {
    const faBuildingsIcon = faBuildings as IconProp;

    const dispatch = useDispatch<any>();

    const { officeStep2Data } = useSelector((state: any) => state);
    const { officeData, isAddOfficeData } = officeStep2Data;

    const schema = Yup.object({
        office_name: Yup.string().required('Office Name is a required field'),
    }).required();

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors, isDirty },
    } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: officeData,
        mode: 'onBlur',
    });

    const HandleChange = async (data: IStep2Props) => {
        const sendData = { ...data, nanoId: organizationId };
        const { payload } = await dispatch(addOfficeData(sendData));
        const { data: payloadData } = payload || {};
        if (payloadData?.message !== '' && payloadData?.status) {
            dispatch(updateCurrentStep(payload));
            getDataListCall();
            handleClose();
            setValue('office_name', '');
        } else {
            toast.error(payload?.message);
        }
    };

    const onClose = async () => {
        if (isDirty) {
            Swal.fire({
                title: 'Warning',
                html:
                    'Are you sure you want to close this form? <br/> ' +
                    'All changes made will be lost.',
                allowOutsideClick: false,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: cancelButtonColor,
                confirmButtonColor: confirmButtonColor,
                cancelButtonText: 'No',
                confirmButtonText: 'Yes',
            }).then(async (result) => {
                if (result?.isConfirmed) {
                    handleClose();
                    setValue('office_name', '');
                }
            });
        } else {
            handleClose();
        }
    };

    return (
        <Modal
            show={showPopup}
            onHide={() => onClose()}
            backdrop="static"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="fs-5 fw-semibold">
                    Add New Offices
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <Form onSubmit={handleSubmit(HandleChange)}>
                    <Row className="justify-content-center">
                        <Col md={12} className="text-center">
                            <Image src={NewOffice} alt="building icon" />
                        </Col>
                        <Col md={12} className="my-3">
                            <Controller
                                name={`office_name`}
                                control={control}
                                render={({
                                    field: { onChange, value },
                                }: any) => (
                                    <>
                                        <InputGroupText
                                            onChangeFunc={onChange}
                                            value={value}
                                            id={`office_name`}
                                            inputName={`office_name`}
                                            inputType={'text'}
                                            placeholder={'Office Name'}
                                            label={null}
                                            inputGroupClassName="mfnw__input-group"
                                            tabIndex={1}
                                            icon={faBuildingsIcon}
                                            disabled={false}
                                            autoFocus={true}
                                            errorText={
                                                errors?.office_name?.message
                                            }
                                        />
                                    </>
                                )}
                            />
                        </Col>
                        <Col md={12}>
                            <Button
                                className="button__details bg-primary w-100 mt-3 text-uppercase"
                                type="submit"
                                tabIndex={2}
                                disabled={isAddOfficeData}
                            >
                                {isAddOfficeData ? <LoaderBtn /> : 'SAVE'}
                            </Button>
                            <Button
                                className="btn-cancel mt-4 w-100 text-uppercase fw-semibold"
                                onClick={() => onClose()}
                                tabIndex={3}
                            >
                                CANCEL
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default OfficePopupStep2;
